import { useEffect, useState } from 'react'
import { calculateFEFOBatches } from '../utils/productUtils'
import { PRODUCT_DETAIL_FIELDS } from '../constant/page-constant'

export function useFEFOBatches(product) {
  const [selectedBatches, setSelectedBatches] = useState([])

  useEffect(() => {
    const quantity = product?.[PRODUCT_DETAIL_FIELDS.QUANTITY]
    const inventory = product?.inventory

    if (quantity && inventory?.length) {
      const batches = calculateFEFOBatches(inventory, quantity)
      setSelectedBatches(batches)
    }
  }, [product?.[PRODUCT_DETAIL_FIELDS.QUANTITY], product?.inventory])

  return selectedBatches
}
